import React from 'react';

const MinimalLayout = ({ children }) => {
  return (
    <div className="bg-page text-neutral-900 min-h-screen flex flex-col font-body">
      {/* Header */}
      <header className="w-full border-b border-neutral-200 bg-white/80 backdrop-blur-sm">
        <div className="max-w-[1280px] mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center">
            <img
              src="/EzyPipe_colored_logo-header_200.png"
              alt="EzyPipe"
              className="h-10"
            />
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-grow flex items-center justify-center p-6 relative overflow-hidden">
        {/* Subtle background pattern */}
        <div className="absolute inset-0 opacity-[0.03]" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%2358adef' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }} />

        {/* Gradient orbs for visual interest */}
        <div className="absolute top-20 -left-32 w-96 h-96 bg-primary/10 rounded-full blur-3xl" />
        <div className="absolute bottom-20 -right-32 w-96 h-96 bg-secondary/10 rounded-full blur-3xl" />

        {children}
      </main>

      {/* Footer */}
      <footer className="w-full py-6 text-center relative z-10">
        <p className="text-xs text-neutral-400">
          © {new Date().getFullYear()}{' '}
          <span className="font-semibold">EzyPipe</span>
          . All rights reserved.
        </p>
      </footer>
    </div>
  );
};

export default MinimalLayout;
